import { render, staticRenderFns } from "./areaList.vue?vue&type=template&id=d0cbec28&scoped=true&"
import script from "./areaList.vue?vue&type=script&lang=js&"
export * from "./areaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cbec28",
  null
  
)

export default component.exports